import http from '@/http'

export function getAll() {
    return http.get(`/api/temas/list`)
}

export function add(data) {
    return http.post(`/api/temas`,data)
}